module.exports = __webpack_public_path__ + "img/special-1.9fcc28dc.png";